var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 8 14","width":"8","height":"14"}},[_c('path',{attrs:{"fill":"currentColor","d":"M3.987.492c.004-.054-.07-.075-.095-.025L.036 8.28a.05.05 0 0 0 .044.072h3.525l-.382 5.155c-.004.054.07.075.095.026l3.82-7.742a.1.1 0 0 0-.089-.145H3.605L3.987.492z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }